import { z } from 'zod';
/**
 * Server configuration, validated at boot. Every external service sits behind
 * an interface so switching is a config change (see productspec §0).
 */
export const configSchema = z.object({
    NODE_ENV: z.enum(['development', 'test', 'production']).default('development'),
    PORT: z.coerce.number().int().min(1).max(65535).default(3000),
    PUBLIC_URL: z.string().url().default('http://localhost:5173'),
    API_URL: z.string().url().default('http://localhost:3000'),
    /** Secret used to sign session cookies. At least 32 chars in production. */
    SESSION_SECRET: z
        .string()
        .min(32)
        .refine((v) => v !== 'change-me', 'SESSION_SECRET must be set to a real value'),
    DATABASE_URL: z.string().url(),
    /** Mail — Resend behind the MailSender interface. */
    RESEND_API_KEY: z.string().min(1),
    MAIL_FROM: z.string().min(1).default('Noti <no-reply@hopon.be>'),
    MAIL_DAILY_LIMIT: z.coerce.number().int().min(1).default(500),
    /** Storage — S3-compatible (Backblaze B2) behind the Storage interface. */
    B2_KEY_ID: z.string().min(1),
    B2_APPLICATION_KEY: z.string().min(1),
    B2_BUCKET: z.string().min(1),
    B2_ENDPOINT: z.string().url(),
    /** Google OIDC. */
    GOOGLE_CLIENT_ID: z.string().min(1),
    GOOGLE_CLIENT_SECRET: z.string().min(1),
    GOOGLE_REDIRECT_URI: z.string().url(),
});
//# sourceMappingURL=config.schema.js.map